var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart89-template',{attrs:{"board-ids":[518],"data-type":_vm.dataType,"graph-id":89,"date-field":"$.body.inputA_3","count-fields":['body.inputA_7'],"title":"작업환경측정결과 현황","unit":"건"}})
}
var staticRenderFns = []

export { render, staticRenderFns }